'use client'

import { HumanOnly } from '@/shared/lib/seo/bot/HumanOnly'

import { useSiteNotice } from '../model/useSiteNotice'

import cl from './SiteNotices.module.scss'

export const SiteNotices = (): JSX.Element | null => {
	const current = useSiteNotice().find(notice => notice.isVisible)

	if (!current) {
		return null
	}

	return (
		<HumanOnly>
			<div className={cl.root}>
				<div key={current.id} className={cl.slide}>
					{current.render()}
				</div>
			</div>
		</HumanOnly>
	)
}
